<template src="./vehicleservicehistory.html"></template>
<script>
  import { mapState } from "vuex";
  import Axios from "axios";
  import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
  var moment = require("moment");
  export default {
    components: {
      DocumentPopup,
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
    },
    props: ["NewVehicle", "type"],
    data() {
      return {
        ImageEndpoint: Endpoints.Helper.Image + "/",
        Services: [],
        TotalCost: 0,
        MileageUnit: "Mileage",
      };
    },
    mounted() {
      setTimeout(() => {
        this.GetVehicleServices();
      }, 4000);
      var CompanyData = JSON.parse(localStorage.getItem("Company"));
      if (CompanyData.mileage_unit == 2) {
        this.MileageUnit = "KM";
      }
    },
    methods: {
      GetVehicleServices() {
        var obj = { token: localStorage.getItem("token") };
        if (this.type === "Asset") {
          obj.asset_id = this.NewVehicle.id;
        } else {
          obj.vehicle_id = this.NewVehicle.id;
        }
        obj.type = this.type;
        Axios.post(Endpoints.Vehicle.Services, obj).then((Response) => {
          if (Response.data.success) {
            this.Services = Response.data.services;
            this.TotalCost = Response.data.total_cost;
          }
        });
      },
      AddServiceDocument() {
        this.$parent.AddDocument("service");
      },
      EditServiceDocument(document) {
        this.$parent.EditDocument(document);
      },
      DeleteServiceDocument(document_id) {
        this.$parent.DeleteDocument(document_id);
      },
    },
  };
</script>
